import React from 'react';
import { useSelector } from 'react-redux';
import AddTickets from '../../../event-create/components/step-2/addTickets';
import { getPriceBreakup } from '../../../event-create/api';
import { camelToSnakeCase } from '../../../../utils/commonUtils';

const Tickets = ({ stateName = 'eventDashboard', onChange, isAdmin, readOnly = false }) => {
  const { eventDetails: eventData, priceBreakups } = useSelector((state) => state[stateName || 'eventDashboard']);

  const setTickets = (tickets, callback) => {
    onChange({ ...eventData, smp_detail_entity_set: tickets }, 'Saved', callback);
  }

  return ( 
    <div className='pt-[36px] px-[80px] flex-1'>
      <AddTickets 
        title="Tickets"
        className='pt-[36px] px-[80px]'
        tickets={eventData?.smp_detail_entity_set} 
        setTickets={setTickets}
        isAdmin={isAdmin}
        allowNameEdit={eventData?.status !== 'APPROVED'}
        readOnly={readOnly}
        businessConfig={{proof_data:'true'}}
        priceBreakups={priceBreakups}
        getPriceBreakup={(price) => getPriceBreakup(price, camelToSnakeCase(stateName || 'eventDashboard')?.toUpperCase())}
      />
    </div>
   
   
  )
}

export default Tickets;